import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export interface CollapseChevronProps {
  collapsed: boolean;
  fontSize?: number;
}

/** The expand/collapse indicator shared by collapsible section headers. */
export function CollapseChevron({ collapsed, fontSize = 18 }: CollapseChevronProps) {
  return collapsed ? <ExpandMoreIcon sx={{ fontSize }} /> : <ExpandLessIcon sx={{ fontSize }} />;
}
